<div class="custom-colors" *ngIf="!websiteBuilderService.spinnerShow">
    <div class="wrapper">
        <header id="header">
            <div class="container">
                <div class="header-bar">
                    <div class="navbar-top">
                        <button type="button" class="menu-btn-sandwich" (click)="toggleMobileMenu()">
                            <span class="icon-bar"></span>
                            <span class="icon-bar"></span>
                            <span class="icon-bar"></span>
                        </button>
                        <div class="_logo">
                            <a href="javascript:;"
                               *ngIf="websiteBuilderService.data.data.websiteLogo"
                               [ngStyle]="{'background-image':  ('url(' + websiteBuilderService.data.data.websiteLogo + ')')}">
                                <img [src]="websiteBuilderService.data.data.websiteLogo">
                            </a>
                        </div>
                    </div>
                    <nav class="navbar-bottom _menu" id="menuToggle" [ngClass]="{'navbar-bottom-show': showMobileMenu}">
                        <ul>
                            <ng-container *ngFor="let item of websiteBuilderService.data.data.websiteParts;">
                                <li class="menu-item" *ngIf="item.isPresent && item.isShowInMenu"
                                    [attr.data-href]="item.navLink"
                                    [ngClass]="{'current': websiteBuilderService.data.data.currentNavLinkMenu == item.navLink}">
                                    <a href="javascript:;" (click)="goToLink(item.navLink)">{{item.navName}}</a>
                                </li>
                            </ng-container>
                            <li class="menu-item">
                                <a>Login</a>
                            </li>
                        </ul>
                    </nav>
                </div>
            </div>
        </header>

        <main>
            <ng-container *ngFor="let pageKey of websiteBuilderService.data.data.pageKeys; let index = index;">
                <ng-container
                    *ngIf="websiteBuilderService.data.data.websitePages[pageKey].isPresent && websiteBuilderService.data.data.websitePages[pageKey] as item"
                    [ngSwitch]="websiteBuilderService.data.data.webView">

                    <ng-container *ngSwitchCase="websiteBuilderView.index">

                        <section [attr.id]="item.navLink"
                                 class="welcome-header"
                                 *ngIf="pageKey === websitePage.welcome"
                                 [style.background-image]="item.sliderImage ? 'url('+item.sliderImage+')' : null">
                            <div class="_container" *ngIf="item.headline || item.text">
                                <div class="_wrap">
                                    <div class="_inner">
                                        <h1 [innerHTML]="item.headline | nl2br"></h1>
                                        <p [innerHTML]="item.text | nl2br"></p>
                                    </div>
                                </div>
                                <a (click)="learnMoreClick()" class="_btn-more">LEARN MORE</a>
                            </div>
                        </section>

                        <section [attr.id]="item.navLink" class="section-about" *ngIf="pageKey === websitePage.about">
                            <div class="container">
                                <article class="row">
                                    <div class="col-lg-6">
                                        <div class="module-title">
                                            <h4 class="text-left">About Us</h4>
                                        </div>
                                        <h3 class="heading-title animated" data-animate="bounceInLeft" [innerHTML]="item.headline | nl2br"></h3>
                                        <p class="animated" data-animate="bounceInRight" [innerHTML]="item.text | nl2br"></p>
                                    </div>
                                    <div class="col-lg-6">
                                        <img src="{{ item.imageUrl }}">
                                    </div>
                                </article>
                            </div>
                        </section>

                        <section [attr.id]="item.navLink" class="section-welcome-message" *ngIf="pageKey === websitePage.welcomeMessage">
                            <div class="container">
                                <div class="module-title">
                                    <h4>Welcome</h4>
                                </div>
                                <article>
                                    <h3 class="heading-title" [innerHTML]="item.headline | nl2br"></h3>
                                    <p [innerHTML]="item.text | nl2br"></p>
                                </article>
                            </div>
                        </section>

                        <section *ngIf="pageKey === websitePage.gallery"
                                 [attr.id]="item.navLink"
                                 class="section-grids"
                                 [ngClass]="{
                             'section-carousel ' : item.type == 'sidebar',
                             'section-parallax': item.type == 'parallax',
                             'section-grid-masonry': item.type == 'grid'
                         }">
                            <div class="container slide" *ngIf="item.type == 'sidebar'" site-carousel>
                                <div class="module-title">
                                    <h4>Gallery</h4>
                                </div>
                                <div class="module-inner">
                                    <div class="items">
                                        <div class="item"
                                             *ngFor="let image of item.galleryImages; let index = index; let first = first;"
                                             [ngClass]="{'active' : first}">
                                            <div class="item-inner">
                                                <div class="img">
                                                    <div class="img-inner"
                                                         [ngStyle]="{'background-image':  ('url(' + image.imageUrl + ')')}">
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="carousel-indicators" *ngIf="item.type == 'sidebar'">
                                        <div class="item-point"
                                             *ngFor="let image of item.galleryImages; let index = index; let first = first;"
                                             [ngClass]="{'active' : first}"
                                             data-target=".section-carousel"
                                             [attr.data-slide-to]="index">
                                            <div class="text" *ngIf="image.captionText">
                                                <div class="text-inner">
                                                    <div class="title">
                                                        <div class="title-inner">
                                                            <h3 [innerHTML]="image.captionText | nl2br"></h3>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="container slide" *ngIf="item.type != 'sidebar'">
                                <div class="module-title">
                                    <h4>Gallery</h4>
                                </div>
                                <div class="module-inner">
                                    <div class="items">
                                        <div class="item"
                                             *ngFor="let image of item.galleryImages; let index = index; let first = first;"
                                             [ngClass]="{'active' : first}">
                                            <div class="item-inner">
                                                <div class="img">
                                                    <div class="img-inner"
                                                         [ngStyle]="{'background-image':  ('url(' + image.imageUrl + ')')}">
                                                    </div>
                                                </div>
                                                <div class="text">
                                                    <div class="text-inner">
                                                        <div class="title">
                                                            <div class="title-inner">
                                                                <h3 [innerHTML]="image.captionText | nl2br"></h3>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>

                        <section *ngIf="pageKey == websitePage.amenities" [attr.id]="item.navLink" class="section-amenity">
                            <div class="container">
                                <div class="module-title">
                                    <h4>Amenities</h4>
                                </div>
                                <div class="module-inner">
                                    <h3 class="heading-title text-uppercase text-center">{{websiteBuilderService.data.data.websiteTitle}} has {{amenities.length}} amenities</h3>

                                    <ul class="list-unstyled amenity-list">
                                        <li *ngFor="let amenity of amenities">
                                            <div class="amenity-ico" [ngStyle]="getAmenityIcoStyle(amenity)"></div>
                                            <span>{{amenity.name}}</span>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </section>

                        <section [attr.id]="item.navLink" class="section-neighbourhood" *ngIf="item.name == 'Neighbourhood'">
                            <div class="container">
                                <div class="module-title">
                                    <h4>Neighbourhood</h4>
                                </div>
                                <div class="module-inner">
                                    <div class="map-wrap">
                                        <agm-map class="map" [latitude]="item.lat"
                                                 [longitude]="item.lng"
                                                 [zoom]="item.zoom"
                                                 [fullscreenControl]="false"
                                                 [streetViewControl]="false"
                                                 (mapReady)="onMapReady($event, item)"
                                                 (centerChange)="onMapCenterChange($event, item)"
                                                 (boundsChange)="resize($event, item)">
                                            <agm-marker *ngIf="!item.streetViewEnabled"
                                                        [latitude]="item.lat"
                                                        [longitude]="item.lng">
                                            </agm-marker>
                                        </agm-map>
                                    </div>
                                    <div class="block-info" *ngIf="item.whatIsNearby">
                                        <h2>What's nearby</h2>
                                        <p class="description" [innerHTML]="item.whatIsNearby | nl2br"></p>
                                    </div>
                                </div>
                            </div>
                        </section>

                        <section [attr.id]="item.navLink" class="section-contacts" *ngIf="item.name == 'Contact'">
                            <div class="container">
                                <div class="contacts-inner">
                                    <div class="contact-details">
                                        <h3 class="contact-title" *ngIf="item.companyName">{{item.companyName}}</h3>
                                        <div class="contact-details-inner">
                                            <div class="item" *ngIf="item.addressEnabled">
                                                <div class="icon">
                                                    <i class="fa fa-building-o"></i>
                                                </div>
                                                <div class="text">
                                                    <h5 class="c-title">Address</h5>
                                                    <p class="c-text">{{ item.address }}</p>
                                                </div>
                                            </div>

                                            <div class="item" *ngIf="item.emailEnabled">
                                                <div class="icon">
                                                    <i class="fa fa-envelope-o"></i>
                                                </div>
                                                <div class="text">
                                                    <h5 class="c-title">Email</h5>
                                                    <p class="c-text">
                                                        <a href="mailto:{{ item.email }}">{{ item.email }}</a>
                                                    </p>
                                                </div>
                                            </div>

                                            <div class="item phone-type-phone" *ngIf="item.phoneEnabled">
                                                <div class="icon">
                                                    <i class="fa fa-phone"></i>
                                                </div>
                                                <div class="text">
                                                    <h5 class="c-title">Phone</h5>
                                                    <p class="c-text">
                                                        <a href="tel:{{ item.phone }}">{{ item.phone }}</a>
                                                    </p>
                                                </div>
                                            </div>

                                            <div class="item phone-type-phone" *ngIf="item.faxEnabled">
                                                <div class="icon">
                                                    <i class="fa fa-fax"></i>
                                                </div>
                                                <div class="text">
                                                    <h5 class="c-title">Fax</h5>
                                                    <p class="c-text">
                                                        <a href="tel:{{ item.fax }}">{{ item.fax }}</a>
                                                    </p>
                                                </div>
                                            </div>


                                            <div class="item" *ngIf="item.officeHoursEnabled">
                                                <div class="icon">
                                                    <i class="fa fa-clock-o"></i>
                                                </div>
                                                <div class="text">
                                                    <h5 class="c-title">Office Hours</h5>
                                                    <p class="c-text">
                                                        <span *ngFor="let hour of item.officeHours">{{ hour }}</span><br/>
                                                    </p>
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                    <div class="contact-form" *ngIf="item.formEmailEnabled && item.formEmail">
                                        <div class="module-title">
                                            <h4>Contact Us</h4>
                                        </div>
                                        <div class="contact-form-inner">
                                            <div class="row">
                                                <div class="col-sm-6">
                                                    <div class="form-group">
                                                        <input type="text" class="form-control" placeholder="Name"/>
                                                    </div>
                                                </div>
                                                <div class="col-sm-6">
                                                    <div class="form-group">
                                                        <input type="text" class="form-control" placeholder="Phone"/>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="row">
                                                <div class="col-sm-12">
                                                    <div class="form-group">
                                                        <input type="text" class="form-control" placeholder="Email"/>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="row">
                                                <div class="col-sm-12">
                                                    <div class="form-group">
                                                        <textarea class="form-control" placeholder="Message"></textarea>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="form-submit">
                                                <button class="btn-custom">Send Message</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                    </ng-container>
                    <ng-container *ngSwitchCase="websiteBuilderView.documents">
                        <div class="page-documents" [attr.id]="item.navLink" *ngIf="item.name == 'Documents and Forms'">
                            <section></section>
                            <section class="header-documents">
                                <div class="container">
                                    <h1>DOCUMENTS & FORMS</h1>
                                </div>
                            </section>
                            <section class="section-documents">
                                <div class="container">
                                    <div class="items row">
                                        <div class="col-sm-10 col-sm-offset-1">
                                            <ul>
                                                <ng-template #recursiveList let-list>
                                                    <li *ngFor="let item of list" [class.show-folder]="item.showFolder">
                                                        <a *ngIf="item.type == 'file'"
                                                           class="item"
                                                           href="{{item.fileViewPath}}"
                                                           target="_blank">
                                                            <span class="doc-ext text-uppercase">{{item.ext}}</span>
                                                            <i class="doc-icon fa fa-file-o fa-file-{{item.ext}}-o"></i>
                                                            <span class="doc-title">{{item.name}}</span>
                                                        </a>
                                                        <ng-container *ngIf="item.type == 'directory' && item.children.length > 0">
                                                            <a href="javascript:;"
                                                               class="item"
                                                               (click)="item.showFolder = !item.showFolder">
                                                                <i class="doc-icon fa fa-file-o fa-file-folder-o"></i>
                                                                <span class="doc-title">{{item.name}}</span>
                                                            </a>
                                                            <ul>
                                                                <ng-container *ngTemplateOutlet="recursiveList; context:{ $implicit: item.children }">
                                                                </ng-container>
                                                            </ul>
                                                        </ng-container>
                                                    </li>
                                                </ng-template>
                                                <ng-container *ngTemplateOutlet="recursiveList; context:{ $implicit: websiteBuilderService.data.data.publicDocuments }">
                                                </ng-container>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </section>
                        </div>
                    </ng-container>

                    <!-- Announcements -->
                    <ng-container *ngSwitchCase="websiteBuilderView.announcements">
                        <div class="page-notices" [attr.id]="item.navLink" *ngIf="item.navLink == 'announcements'">
                            <section class="header-notices">
                                <div class="container">
                                    <h1>ANNOUNCEMENTS</h1>
                                </div>
                            </section>
                            <section class="section-notices container content">
                                <ng-container *ngIf="websiteBuilderService.data.data.announcements.length > 0">
                                    <ul class="notices-nav">
                                        <li *ngFor="let notice of websiteBuilderService.data.data.announcements" class="itenm" [ngClass]="{active: websiteBuilderService.data.data.selectedNoticeId === notice.id}">
                                            <a href="javascript://" (click)="websiteBuilderService.data.data.selectedNoticeId = notice.id">{{notice.title}}</a>
                                        </li>
                                    </ul>
                                    <div class="notice-content-wrapper" style="position: relative; overflow: auto;">
                                        <div class="notice-header">
                                            <h4 class="title">{{selectedNotice?.title || '&nbsp;'}}</h4>
                                            <div class="date">{{(selectedNotice?.periodBegin|date) || '&nbsp;'}}</div>
                                        </div>
                                        <div *ngIf="websiteBuilderService.data.data.selectedNoticeId && selectedNotice" class="notice-content">
                                            <div *ngIf="!selectedNotice?.document" [innerHTML]="selectedNotice?.safeText"></div>
                                            <announcement-view *ngIf="selectedNotice?.document" [fileDocument]="selectedNotice?.document"></announcement-view>
                                        </div>
                                    </div>
                                </ng-container>
                                <div *ngIf="!websiteBuilderService.data.data.announcements.length" class="empty-result-message">
                                    <div class="icon-64 list"></div>
                                    <span>You have no announcement listed on the system</span>
                                </div>
                            </section>
                            <section class="section-notices-subscription container regular">
                                <div class="title">Subscribe</div>
                                <form class="form-inline">
                                    <div class="form-group name">
                                        <input type="text" class="form-control" id="subscribe-name" placeholder="Name">
                                    </div>
                                    <div class="form-group email">
                                        <input type="email" class="form-control" id="subscribe-email" placeholder="Email">
                                    </div>
                                    <button type="submit" class="btn btn-custom">Subscribe</button>
                                </form>
                            </section>
                        </div>
                    </ng-container>

                    <ng-container *ngSwitchCase="websiteBuilderView.buildingFeatures">
                        <div class="page-amenities" [attr.id]="item.navLink" *ngIf="pageKey === websitePage.buildingFeatures">
                            <section class="header-notices">
                                <div class="container">
                                    <h1>{{item.name}}</h1>
                                </div>
                            </section>
                            <section class="section-grids container content"
                                     [ngClass]="{
                             'section-grid-tiles' : item.type == 'tiles',
                             'section-grid-checkerboard': item.type == 'checkerboard',
                             'section-grid-list': item.type == 'list'
                             }">
                                <div class="container">
                                    <div class="items">
                                        <div class="item" *ngFor="let image of item.buildingFeaturesImages;">
                                            <div class="item-inner">
                                                <div class="img">
                                                    <div class="img-inner" [ngStyle]="{'background-image':  ('url(' + image.imageUrl + ')')}">
                                                    </div>
                                                </div>
                                                <div class="text">
                                                    <div class="text-inner">
                                                        <div class="title" *ngIf="image.captionText">
                                                            <div class="title-inner">
                                                                <h3 [innerHTML]="image.captionText | nl2br"></h3>
                                                            </div>
                                                        </div>
                                                        <div class="description" *ngIf="image.descriptionText">
                                                            <div class="description-inner">
                                                                <p [innerHTML]="image.descriptionText | nl2br"></p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </section>
                        </div>
                    </ng-container>

                </ng-container>
            </ng-container>
        </main>
        <footer class="footer">
            <div class="container">
                <ng-container *ngFor="let item of websiteBuilderService.data.data.websiteParts; let index = index;">
                    <ng-container *ngIf="item.isPresent && item.name == 'Contact'">
                        <div class="socials">
                            <a target="_blank"
                               *ngIf="item.social.linkedInEnabled && item.social.linkedIn"
                               class="social-btn"
                               [href]="item.social.linkedIn">
                                <i class="fa fa-linkedin"></i>
                            </a>
                            <a target="_blank"
                               *ngIf="item.social.facebookEnabled && item.social.facebook"
                               class="social-btn"
                               [href]="item.social.facebook">
                                <i class="fa fa-facebook"></i>
                            </a>
                            <a target="_blank"
                               *ngIf="item.social.twitterEnabled && item.social.twitter"
                               class="social-btn"
                               [href]="item.social.twitter">
                                <i class="fa fa-twitter"></i>
                            </a>
                        </div>
                    </ng-container>
                </ng-container>
                <div class="copyright">Powered By Max Condo Club</div>
            </div>
        </footer>
    </div>
</div>



// WEBPACK FOOTER //
// /app/src/app/views/website-builder/website-builder-view/website-builder-view.component.html